import { Box, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { checkAuth } from "utils/webAPI";

// Web-mode gate: renders children only after /api/me confirms a valid session.
// When running inside Electron we skip the check entirely (no server).
export default function AuthGuard({ children }) {
  const [state, setState] = useState(() =>
    window.__isWebMode ? "checking" : "authed"
  );
  const location = useLocation();

  useEffect(() => {
    if (!window.__isWebMode) return;
    let cancelled = false;
    checkAuth().then((ok) => {
      if (cancelled) return;
      setState(ok ? "authed" : "anon");
    });
    return () => { cancelled = true; };
  }, []);

  if (state === "checking") {
    return (
      <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <CircularProgress />
      </Box>
    );
  }
  if (state === "anon") {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
